<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">
    <template #cell(name)="data">
      {{ data.item.title }}
    </template>

    <template #cell(thumbnail)="data">
      <b-img thumbnail width="350px" height="auto" :src="data.item.thumbnail"/>
    </template>


    <template #cell(status)="data">
      <status-changer item-type="course" :item="data.item"/>
    </template>


    <template #cell(action)="data">
      <div v-if="restoreState == true">
        <span
            class="h4 "
            v-b-tooltip.hover
            title="حذف دائمی"

        >
        <b-icon icon="trash" class="m-3" @click="ForceDeleteCourse(data.item)"></b-icon>
      </span>

        <span
            class="h4 "
            v-b-tooltip.hover
            title="بازگردانی"

        >
        <b-icon
            icon="arrow-clockwise"
            class="m-3"
            @click="restore(data.item)"
        ></b-icon>
      </span>

      </div>
      <div v-else>
              <span class="h4 " v-b-tooltip.hover title="حذف">
        <b-icon icon="trash" class="m-3" @click="deleteCourse(data.item)"></b-icon>
      </span>

        <span class="h4 " v-b-tooltip.hover title="ویرایش">
        <router-link target="_blank" class="text-dark"
            :to="{ name: 'EditCourse', params: { slug: data.item.slug } }"
        >
          <b-icon icon="pencil" class="m-3"></b-icon>
        </router-link>


      </span>

        <duplicate-item :item="data.item" item-type="course"/>


      </div>
    </template>
  </b-table>
</template>
<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";

export default {
  name: "courseItems",
  components: {StatusChanger, DuplicateItem,},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "name", label: "عنوان"},
        {key: "thumbnail", label: "تصویر دوره"},
        {key: "status", label: "وضعیت"},
        {key: "action", label: ""},
      ],
    };
  },
  methods: {
    formatNumber,
    deleteCourse(item) {
      if(confirm('آیا از حذف دوره اطمینان دارید؟')){
        this.$store.dispatch("Course/deleteCourse", item);
      }
    },
    restore(course) {
      if (confirm(' بازگردانی  شود؟')) {
        this.$store.dispatch("Course/restoreCourse", course);
      }
    },
    ForceDeleteCourse(course) {
      if (confirm('آیا از حذف  دائمی اطمینان دارید؟')) {
        this.$store.dispatch("Course/forceDeleteCourse", course);
      }
    },
  },
};
</script>


<style>

</style>